import { gql } from '@apollo/client';

export const SET_OBJECT_GROUP_COLLABORATORS_MUTATION = gql`
  mutation SetObjectGroupCollaboratorsMutation(
    $id: String!
    $collaborators: [ObjectGroupCollaboratorInput!]!
  ) {
    setObjectGroupCollaborators(id: $id, collaborators: $collaborators) {
      ... on SetObjectGroupCollaboratorsSuccess {
        result
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
